export const ATTACH_MERCHANT_TO_SESSION = `mutation AttachMerchantToSession($merchantId: ID!){
    attachMerchantToSession(merchantId: $merchantId){
        token
    }
}`;
